/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_Item_2Inputs */



/**
* | output |
* | --- |
* | "False positives (incorrectly blocked requests) may occur." |
*
* @param {Guardrails_Short_Item_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_item_2 = /** @type {((inputs?: Guardrails_Short_Item_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_Item_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("False Positives (falsch blockierte Anfragen) können auftreten")
	return /** @type {LocalizedString} */ ("False positives (incorrectly blocked requests) may occur.")
});